<template>
  <div>
    <div class="card-filter-section d-flex align-items-center mt-0">
      <p class="task-timesheet m-0">
        Project Scope
      </p>
      <div class="role-buttons ml-auto d-flex flex-wrap align-items-center">
        <!-- add skill button  -->
        <table-button
          v-b-toggle.addProjectScope
          btn-name="Add Scope"
        />
        <!-- add skill button  -->
      </div>
      <Help
        v-show="$store.state.app.userManualList"
        code="PS"
      />
    </div>
    <!--Filter start-->
    <div class="card-filter-section">
      <div class="d-flex align-items-center flex-wrap justify-content-between">
        <div class="d-flex align-items-center justify-content-start flex-wrap">
          <p class="filter-title">
            Filters:
          </p>

          <div class="">
            <custom-dropdown
              v-model="is_active"
              :options="isActiveList"
              :search-box="false"
              :hide-close="true"
              label="Active"
              icon="EditIcon"
            />
          </div>
          <option-drop-down v-model="perPage" />
        </div>
        <div class="d-flex align-items-center">
          <b-input-group
            class="input-group-merge search-project"
            style="min-width: 250px; max-width: 250px; width: 250px"
          >
            <b-form-input
              v-model="debouncedSearch"
              placeholder="Search by Project Scope"
            />

            <b-input-group-append is-text>
              <feather-icon
                v-if="debouncedSearch"
                icon="XIcon"
                @click="debouncedSearch = null,search = null"
              />
              <feather-icon icon="SearchIcon" />
            </b-input-group-append>
          </b-input-group>

          <div class="ml-1">
            <button
              class="apply-filter filterRedesign mr-1"
              @click="getProjectScopeData()"
            >
              Apply Filter
            </button>
            <button
              class="apply-filter-clear filterRedesign"
              @click="clearFilter()"
            >
              Clear
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--Filter End-->

    <div class="table horizontal-long-line">

      <!-- Table start from here -->
      <table-loader
        v-if="loading"
        :fields="fields"
      />

      <b-row v-else>
        <b-col cols="12">
          <b-table
            responsive
            :items="items"
            :fields="fields"
            class="scrollable-element tableDesigns"
          >
            <template #cell(name)="data">
              <div class="media centeralign">
                <div class="media-aside align-self-center">
                  <b-avatar
                    :text="data.item.name.charAt(0)"
                    :style="{ 'background-color': '#' + data.item.color }"
                    size="40"
                  />
                </div>
                <div>
                  <p
                    class=""
                    :style="{ color: '#' + data.item.color }"
                  >
                    {{ data.item.name }}
                  </p>
                </div>
              </div>
            </template>
            <template #cell(active)="data">
              <b-form-checkbox
                v-model="data.item.is_active"
                class="custom-control-success"
                name="check-button"
                size="md"
                switch
                @change="changeStatus(data.item)"
              >
                <span class="switch-icon-left">
                  <feather-icon icon="CheckIcon" />
                </span>
                <span class="switch-icon-right">
                  <feather-icon icon="XIcon" />
                </span>
              </b-form-checkbox>
            </template>
            <template #cell(action)="data">
              <span>
                <feather-icon
                  v-b-tooltip.hover.top="'Edit'"
                  icon="EditIcon"
                  role="button"
                  class="mr-1 text-dark"
                  size="18"
                  @click="edit(data.item)"
                />
                <feather-icon
                  v-b-tooltip.hover.top="'Delete'"
                  icon="Trash2Icon"
                  role="button"
                  class="text-danger"
                  size="18"
                  @click="deleteConfirmation(data.item.id)"
                />
              </span>
            </template>
          </b-table>
          <!-- table end -->
          <!-- data table complete -->
          <img
            v-if="totalCount === 0"
            src="@/assets/images/nodatafound/nodata.svg"
            alt="no-data"
            class="no-data-img"
          >
        </b-col>

      </b-row>
      <Pagination
        v-if="totalCount>0 && !loading"
        :current-page="currentPage"
        :per-page="perPage"
        :total-count="totalCount"
        @currentPage="currentPage = $event"
      />
      <!-- add project Scope form start -->
      <project-scope-form
        ref="projectScopeForm"
        @projectScopeList="getProjectScopeData"
      />
      <!-- add project Scope form complete here -->
    </div>
  </div>
</template>

<script>
import { eventBus } from '@/main'
import customDropdown from '@/components/dropdown/customDropdown.vue'
import debounce from 'lodash/debounce'
import TableButton from '../../@core/components/buttons/TableButton.vue'
import ProjectScopeForm from '../../@core/components/table-from/ProjectScopeForm.vue'

export default {
  name: 'ProjectScope',
  components: {
    TableButton,
    ProjectScopeForm,
    customDropdown,
  },

  data() {
    return {
      id: 'project Scope',
      search: null,
      totalCount: 0,
      currentPage: 1,
      perPage: 10,
      loading: true,
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      is_active: 'active',
      fields: [
        {
          key: 'name',
          label: 'Name',
          sortable: true,
          thStyle: { width: '300px' },
          tdStyle: { width: '300px' },
        },
        {
          key: 'active',
          label: 'Active',
          thClass: 'text-right',
          tdClass: 'text-right',
        },
        {
          key: 'action',
          label: 'Action',
          thClass: 'text-right',
          tdClass: 'text-right',
          thStyle: { width: '120px' },
          tdStyle: { width: '120px' },
        },
      ],
      items: [],
    }
  },

  computed: {
    debouncedSearch: {
      get() {
        return this.search
      },
      set: debounce(function (value) {
        this.search = value
        this.getProjectScopeData()
      }, 750),
    },
  },
  watch: {
    perPage() {
      if (this.currentPage === 1) {
        this.getProjectScopeData()
      } else {
        this.currentPage = 1
      }
    },
    /**
     * @description on page number change Call getProjectScopeData()
     */
    currentPage: {
      handler(value) {
        if (value) {
          this.getProjectScopeData()
        }
      },
    },
  },
  mounted() {
    eventBus.$on('project Scope', data => {
      if (data) {
        this.search = data.search
        this.is_active = data.is_active
        this.$root.$emit('bv::toggle::collapse', 'search')
      }
    })
    this.getProjectScopeData()
  },
  methods: {

    /**
     * @description Get Project Scope List
     * @method POST
     * @returns items (variable)(project scope list)
     */
    async getProjectScopeData(page) {
      this.loading = true

      this.currentPage = page || this.currentPage
      const input = {
        page: this.currentPage,
        per_page: this.perPage,
        sort_field: this.sortBy,
        sort_order: this.sortDesc ? 'desc' : 'asc',
        is_active: this.is_active && this.is_active !== 'all_data'
          ? this.is_active === 'active'
          : '',
        search: this.search,
      }
      const response = await this.getHTTPPostResponse(
        'admin/master/project-scope',
        input,
        false,
      )
      if (response && response.data) {
        const { data } = response

        this.items = data.project_scopes
        this.totalCount = data.count
      }
      this.loading = false
    },

    /**
     * @description For Edit Primary scope pass data of Primary scope to Primary scope table form
     * @emits edit-client
     */
    edit(data) {
      // to emit the event
      this.$refs.projectScopeForm.id = data.id
      this.$refs.projectScopeForm.name = data.name
      this.$refs.projectScopeForm.scopeColor = `#${data.color}`
      this.$root.$emit('bv::toggle::collapse', 'addProjectScope')
    },

    /**
     * @description Change projectScope status
     * @param {index}  array index
     * @param {value}  value (true, false)
     * @returns if change then call updateStatus method
     */
    async changeStatus(index) {
      const projectScope = this.items.find(projectScope => projectScope === index)
      if (!projectScope) {
        return false
      }
      const label = projectScope.is_active ? 'Active' : 'Deactive'
      const title = `Are you sure ${label} Scope?`
      const conformation = await this.conformationAlert(false, title, label)

      if (conformation.isConfirmed === true) {
        this.updateStatus(projectScope)
        this.getProjectScopeData()
      } else {
        this.items = []
        this.getProjectScopeData()
      }
    },

    /**
     * @description Update projectScope status
     * @method POST
     * @param {data} data(projectScopes Information in Array)
     * @returns projectScope Status update
     */
    async updateStatus(data) {
      const response = await this.getHTTPPutResponse(
        `admin/master/project-scope/status/${data.id}`,
        { is_active: data.is_active ? 1 : 0 },
        true,
      )
      if (response && response.status === 200) {
        //
        this.getProjectScopeData()
      }
    },

    /**
     * @description confirmation to delete Primary skill
     * @param {id} primarySkill id
     * @returns if conform to delete call deleteScope function
     */
    async deleteConfirmation(id) {
      const value = await this.conformationAlert(true)
      if (value.isConfirmed === true) {
        this.deleteScope(id)
      }
    },

    /**
     * @description delete project scope
     * @method DELETE
     * @param {id}  projectScope id
     */
    async deleteScope(id) {
      const response = await this.getHTTPDeleteResponse(
        `admin/master/project-scope/delete/${id}`,
        {},
        true,
      )
      if (response && response.status === 200) {
        this.getProjectScopeData()
      }
    },

    /**
     * @description clear all applied filter
     */
    clearFilter() {
      this.search = null
      this.perPage = 10
      this.is_active = 'active'
      this.getProjectScopeData()
    },
  },
}
</script>

<style lang="scss" scoped>
@import "./../../assets/scss/component-css/masterSettingFilter.scss";
</style>
